import { LOAD_JEWELS, LOAD_JEWELS_FILTERS, SET_JEWELS_SELECTED_FILTERS, SET_JEWELS_CURRENTPAGE, SET_JEWELS_LENGTH, LOAD_JEWELS_FAVORITE } from "./actions";

const initialselectedfilters = {
  tags:''
}

const initialState = {
  jewels:[],
  total:0,
  currentpage:0,
  totalpage:0,
  length:12,
  filters:[],
  selectedfilters:initialselectedfilters,
  favorites:[]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_JEWELS:
      return {
        ...state,
        total:action.payload.total,
        currentpage:action.payload.currentpage,
        totalpage:action.payload.totalpage,
        jewels:action.payload.items
      };
      break;
    case LOAD_JEWELS_FILTERS:
      return {
        ...state,
        filters:action.payload
      };
      break;
    case SET_JEWELS_CURRENTPAGE:
        return {
          ...state,
          currentpage: action.payload
        }
        break;
    case SET_JEWELS_LENGTH:
        return {
          ...state,
          length: action.payload
        }
      break;
    case SET_JEWELS_SELECTED_FILTERS:
        let newSelectedFilters = {...state.selectedfilters };
        newSelectedFilters[action.payload.filtername] = action.payload.filters
        return {
          ...state,
          currentpage:0,
          selectedfilters:newSelectedFilters
        }
        break;
        case LOAD_JEWELS_FAVORITE:
          return {
            ...state,
            favorites: action.payload
          }
          break;
    default:
      return state;
  }
};
